import targetNumbersTable from './_table.js'
import template from './index.pug'

export default Vue.extend({
  template: template(),
  components: {
    targetNumbersTable
  },
  data() {
    return {
      targetNumbers: [],
      meta: {}
    }
  },
  created() {
    this.$setPageTitle(this.$t('targetNumbers.index.title'))
    this.$setBreadcrumbs([
      {label: this.$t('breadcrumbs.targetNumbers.index'), route: {}}
    ])
  },
  methods: {
    loadData(queryOptions = {}) {
      API.targetNumbers.index(queryOptions).then(({data, meta}) => {
        this.targetNumbers = data
        this.meta = meta
      })
    }
  }
})
